<template>
  <div class="content">
    <pic-nav></pic-nav>
    <slider-menu :menuData="menuData" hasBackground></slider-menu>
  </div>
</template>

<script>
import picNav from "@/components/Nav";
import sliderMenu from "@/components/SliderMenu";

export default {
  components: { picNav, sliderMenu },
  data() {
    return {
      menuData: [
        {
          path: "/pc/user/accountWithdrawal",
          icon: "",
          title: "账户提现",
        },
        {
          path: "/pc/user/WithdrawalRecord",
          icon: "",
          title: "提现记录",
        },
        {
          path: "/pc/user/account",
          icon: "",
          query: {
            recharge: true,
          },
          title: "账户充值",
        },
        {
          path: "/pc/user/flowRecord",
          icon: "",
          title: "流水记录",
        },
        {
          path: "/pc/user/changePassword",
          icon: "",
          title: "修改密码",
        },
        {
          path: "/pc/accountNumber/index",
          icon: "",
          title: "账号列表",
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pc/user/index.vue